import type { ReactElement } from 'react';
import { Stack, Chip } from '@mui/joy';

interface PortfolioTagsChipsProps {
  tags: string[];
}

const PortfolioTagsChips = ({ tags }: PortfolioTagsChipsProps): ReactElement | null => {
  if (tags.length === 0) {
    return null;
  }

  return (
    <Stack direction="row" flexWrap="wrap" gap={0.5}>
      {tags.map((tag) => (
        <Chip key={tag} color="neutral" size="sm" variant="soft">
          #{tag}
        </Chip>
      ))}
    </Stack>
  );
};

export default PortfolioTagsChips;
